import { render } from "./OrdersPane.vue?vue&type=template&id=129ef7a6&scoped=true"
import script from "./OrdersPane.vue?vue&type=script&lang=js"
export * from "./OrdersPane.vue?vue&type=script&lang=js"

import "./OrdersPane.vue?vue&type=style&index=0&id=129ef7a6&scoped=true&lang=css"
import "./OrdersPane.vue?vue&type=style&index=1&id=129ef7a6&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129ef7a6"],['__file',"src/views/Itineraries/OrdersPane.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "129ef7a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('129ef7a6', __exports__)) {
    console.log('reload')
    api.reload('129ef7a6', __exports__)
  }
  
  module.hot.accept("./OrdersPane.vue?vue&type=template&id=129ef7a6&scoped=true", () => {
    console.log('re-render')
    api.rerender('129ef7a6', render)
  })

}


export default __exports__